import { tableColumns, drawerFilters } from './helpers'
import { useMemo, useState } from 'react'
import { toListTableRows } from './serializers'
import { makeCoreGetRequest } from 'utils/api'
import { useNotification } from 'hooks'
import { EditActionIcon } from 'icons'
import EditStore from './EditStoreUpgrade/EditStore'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import {
  getDepositOptions,
  getHubOptions,
  getShopOptions
} from 'components/shop-reception/admin/api'
import { ListTable } from '@fullscreendigital/carrefour-dex-fe'
import { debounce } from '@mui/material'
import { handleQueryError } from 'utils/helpers'

const CentralizeStores = ({ permissions }) => {
  const { showNotification } = useNotification()
  const [rows, setRows] = useState([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)

  const [selectedRow, setSelectedRow] = useState<DLCProducts>(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [tableState, setTableState] = useState(
    window.history.state.tableState || {
      page: 0,
      rowsPerPage: 5
    }
  )

  const openUpdateModal = () => setIsOpen(true)
  const closeUpdateModal = () => setIsOpen(false)

  const selectRow = (rowId: number | string) => {
    const row = rows.find(item => item.id === rowId)
    if (row) setSelectedRow(row)
  }

  const { data: shopOptions } = getShopOptions(showNotification)

  const { data: depositOptions } = getDepositOptions(showNotification)

  const { data: hubOptions } = getHubOptions(showNotification)

  const filters = useMemo(
    () => drawerFilters({ shopOptions, hubOptions, depositOptions }),
                           [shopOptions, hubOptions, depositOptions]
                         )

  const fetchData = async (page, rowsPerPage, tableFilters) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/shop-reception/delivery-matrix/shops',
          tableFilters,
          page,
          rowsPerPage
        })
      )

      setRows(toListTableRows(response.list, tableColumns))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
        (error: any) =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea datelor pentru tabel.',
          showNotification
        )
      setIsLoading(false)
    }
  }

  return (
    <>
      <EditStore
        isOpen={isOpen}
        closeModal={closeUpdateModal}
        setShouldRefreshData={setShouldRefreshData}
        editItem={selectedRow}
      />

      <ListTable
        rows={rows}
        handleRemoteData={debounce(fetchData, 500)}
        isLoading={isLoading}
        totalCount={totalCount}
        filters={filters}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        rowActions={
          permissions?.canEdit
            ? [
                {
                  label: 'Editeaza',
                  labelColor: 'white',
                  typographyVariant: 'medium',
                  backgroundColor: '#16a085',
                  desktopIcon: <EditActionIcon />,
                  onClick: (e, rowId) => {
                    selectRow(rowId)
                    openUpdateModal()
                  }
                }
              ]
            : []
        }
        filtersButtonLabel="Filtre"
        filtersLabel="Filtre"
        appliedFiltersLabel="Filtre aplicate"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </>
  )
}

export default CentralizeStores
